// to easily copy and paste components
import React from 'react';
import {useTranslation} from 'react-i18next';
import { constants } from "../../common/constants/constants";
import {selectCustomStyles} from '../../common/shared/select.styled';
import Select from 'react-select';
import {Datepicker} from '../../common/Datepicker';
import {RecordExpenseStyled} from './expenses.styled';

export default function ExpensesRecordForm({
    vendors,
    formData,
    onFormDataChanged,
    onDateChanged,
}) {
    const {t} = useTranslation();

    const getPaymentMethodsOptions = params => {
        let options = [
            {value: constants.managerPaymentsOptions.cheque, label: t('offline_payments.cheque')},
            {value: constants.managerPaymentsOptions.wire, label: t('offline_payments.wire')},
            {value: constants.managerPaymentsOptions.cash, label: t('offline_payments.cash')}
        ];
        if (params.bankCharge) {
            options.push({value: constants.managerPaymentsOptions.bankCharge, label: t('payments.bllink_bank_charge')})
        }

        return options;
    }

    return (
        <RecordExpenseStyled>
            <div className={`form-bllink`}>
                <div className="input-item">
                    <label htmlFor="vendor">* {t('expenses.name_of_supplier')}:</label>
                    <Select
                        styles={selectCustomStyles}
                        options={vendors || []}
                        onChange={evt => onFormDataChanged(evt, 'selectedVendor')}
                        value={formData.selectedVendor}
                    />
                </div>
                <div className="input-item">
                    <label htmlFor="date">{t('offline_payments.date')}:</label>
                    <Datepicker
                        placeholder={'dd/mm/yyyy'}
                        defaultValue={new Date()}
                        onDayChange={onDateChanged}
                    />
                </div>

                <div className="input-item">
                    <label htmlFor="payment-method">* {t('expenses.payment_method')}:</label>
                    <Select
                        styles={selectCustomStyles}
                        options={getPaymentMethodsOptions({bankCharge: true}) || []}
                        onChange={evt => onFormDataChanged(evt, 'selectedPaymentMethod')}
                        value={formData.selectedPaymentMethod}
                    />
                </div>

                <div className="input-item">
                    <label htmlFor="payment-frequency">* {t('expenses.payment_frequency')}:</label>
                    <Select
                        styles={selectCustomStyles}
                        options={[
                            {value: constants.APIContract.expenses.oneTime, label: t('expenses.one_time')},
                            {value: constants.APIContract.expenses.recurring, label: t('expenses.recurring')},
                        ]}
                        onChange={evt => onFormDataChanged(evt, 'frequency')}
                        value={formData.frequency}
                    />
                </div>
            </div>
        </RecordExpenseStyled>
    )
}

